import { Container, Graphics, Sprite, Texture, TilingSprite } from 'pixi.js';
import { registerResizableObject } from '../utils/pixi/registerResizableObject';

export class MainMenuSelectorBackgroundView extends Container {
  private readonly backgroundWrapper = new Container().props({
    parent: this,
  });

  private readonly tileSprite = new TilingSprite({
    texture: Texture.from('Bottom_ Fragment_Main_Menu'),
    anchor: { x: 0, y: 1 },
    tileScale: { x: 1, y: 1 },
  }).props({
    parent: this.backgroundWrapper,
    x: -142,
    scaleX: -1,
  });

  private readonly tileSprite2 = new TilingSprite({
    texture: Texture.from('Bottom_ Fragment_Main_Menu'),
    anchor: { x: 0, y: 1 },
  }).props({
    parent: this.backgroundWrapper,
    x: 142,
  });

  private readonly bump = new Sprite().props({
    texture: 'Selected_Tab_Main_Menu',
    parent: this.backgroundWrapper,
    anchor: { x: 0.5, y: 1 },
  });

  private readonly corner = new Sprite().props({
    parent: this,
    x: -440,
    anchor: { x: 0, y: 0 },
    texture: 'Main_Menu_Navigation_Round_Corner',
    visible: false,
  });

  private readonly horizontalMask = this.createMask();

  constructor() {
    super();
    registerResizableObject(this);
  }

  public resize(width: number): void {
    this.tileSprite.width = width;
    this.tileSprite2.width = width;
  }

  public setSelectorPosition(x: number, skipAnimation = false): this {
    if (skipAnimation) {
      this.backgroundWrapper.x = x;
      return this;
    }

    this.backgroundWrapper.tweenTo({ x }, 300, 'quadOut', true);

    return this;
  }

  public setHorizontalSize(value: number): void {
    this.corner.x = -(value * 0.5 + this.corner.width);
    this.horizontalMask.x = this.corner.x;
  }

  public setHorizontalLayout(horizontal: boolean): void {
    [this.tileSprite, this.tileSprite2, this.bump].forEach((sprite) => {
      sprite.scale.y = horizontal ? -1 : 1;
    });
    this.corner.visible = horizontal;
    this.horizontalMask.visible = horizontal;
    this.tileSprite.mask = horizontal ? this.horizontalMask : null;
  }

  private createMask(): Graphics {
    const gfx = new Graphics().props({
      parent: this,
      x: this.corner.x,
      visible: false,
    });

    const curvePoints = [
      { x: 0, y: 0 },
      { x: 1, y: 3 },
      { x: 10, y: 56 },
      { x: 32, y: 104 },
      { x: 52, y: 128 },
      { x: 86, y: 142 },

      { x: this.corner.width, y: this.corner.height },
      { x: this.corner.width, y: this.corner.height + 10 },
      { x: 4000, y: this.corner.height + 10 },
      { x: 4000, y: 0 },
    ];

    curvePoints.forEach(({ x, y }) => {
      gfx.lineTo(x, y);
    });

    gfx.fill(0xff0000);

    return gfx;
  }
}
